import { Box, Container, Flex, Heading, Text, Button } from '@radix-ui/themes';

function About() {
    return (
        <Flex position="absolute" left="0" right="0" style={{ top: 100, bottom: 0, backgroundColor: '#000' }}>
            <Box
                position="absolute"
                left="0"
                display={{ initial: 'none', md: 'block' }}
                style={{
                    top: 340,
                    width: 1000,
                    height: 500,
                    zIndex: 10,
                }}
                className="bg-gradient-to-r from-[#B42029] to-[#000000]"
            />
            <Container size="4" px="5" style={{ zIndex: 20, overflowY: 'auto', paddingBottom: 32 }}>
                <Flex direction="column" width="100%">
                    <Box mt={{ initial: '6', md: '9' }} mb="5">
                        <Heading
                            as="h2"
                            size={{ initial: '7', sm: '8', md: '9' }}
                            style={{ color: '#B42029' }}
                        >
                            Hello, My Name is
                        </Heading>
                    </Box>
                    <Flex
                        width="100%"
                        maxWidth={{ initial: '300px', sm: '400px', md: '500px', lg: '600px' }}
                    >
                        <img
                            src={'/images/Dylan Lawson.png'}
                            alt="Dylan Lawson"
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                            }}
                        />
                    </Flex>
                    <Flex
                        mt="6"
                        direction={{ initial: 'column', md: 'row' }}
                        gap={{ initial: '5', md: '0' }}
                    >
                        <Flex
                            direction="column"
                            gap="4"
                            width="100%"
                            maxWidth={{ initial: '240px', sm: '320px', md: '400px', lg: '480px' }}
                        >
                            <img
                                src={'/images/Headshot.png'}
                                alt="Dylan Lawson"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                }}
                            />
                            <Button
                                asChild
                                size="4"
                                variant="solid"
                                color="gray"
                                highContrast
                                style={{
                                    backgroundColor: '#000',
                                    border: '2px solid #fff',
                                    borderRadius: 0,
                                    color: '#fff',
                                }}
                            >
                                <a
                                    href="/Dylan Lawson Resume 2026.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Text size="5">Download My Resume</Text>
                                </a>
                            </Button>
                        </Flex>
                        <Flex
                            ml={{ initial: '0', md: '6' }}
                            direction="column"
                            justify="center"
                            gap="5"
                            width="100%"
                            style={{ maxWidth: 470 }}
                        >
                            <Text as="p" size={{ initial: '4', sm: '5', md: '6' }} style={{ color: '#fff' }}>
                                As an emerging Graphic Designer, my passion lies in crafting innovative design concepts and captivating
                                visual storytelling. Equipped with a Bachelor of Arts in Communication & Graphic Design from California
                                State University, Chico, I am confident in my ability to bring advanced skills in various design disciplines
                                to the table.
                            </Text>
                            <Text as="p" size={{ initial: '4', sm: '5', md: '6' }} style={{ color: '#fff' }}>
                                I am especially experienced in creating engaging social media posts, concise posters, and bold billboard
                                designs. Moreover I am capable in handling packaging design, photography, and brand development. Ultimately
                                I have a passion for design and the flexibility to be a valuable asset as needed
                            </Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Container>
        </Flex>
    );
}

export default About;
